import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 3;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  `,
  content: css`
    width: 660px;
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    min-width: 520px;
    max-height: 90vh;
    min-height: 0;
    overflow: hidden;

    & > button:first-of-type {
      width: 20px;
      height: 20px;

      & svg {
        width: 16px;
        height: 16px;
      }
    }
  `,
  header: ({ theme }) => css`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    border-bottom: 1px solid ${theme.colors.neutral.variant[20]};
    && {
      padding: 0 24px 16px;
    }
  `,
  headerDescription: css`
    display: flex;
    text-align: center;
  `,
  headerSpacer: css`
    height: 16px;
    width: 100%;
    background-color: red;
  `,
  body: css`
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    width: 100%;
    padding: 0 24px;
  `,
  footer: ({ theme }) => css`
    flex-shrink: 0;
    border-top: 1px solid ${theme.colors.neutral.variant[20]};
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 24px 0;
  `,
  list: css`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: auto;
    gap: 4px;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  `,
  collapsibleRow: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[70]};
    border-radius: 14px;
    border: 1px solid ${theme.colors.neutral.variant[0]};
    background-color: ${theme.colors.neutral.variant[0]};
    &:hover {
      border: 1px solid ${theme.colors.neutral.variant[10]};
      background-color: ${theme.colors.neutral.variant[5]};
    }
  `,
  deletingRow: ({ theme }) => css`
    display: flex;
    width: 100%;
    height: 50px;
    padding: 6px 12px 7px 22px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 14px;
    border: 1px solid ${theme.colors.neutral.variant[20]};
  `,
  deletingTitleRow: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  deletingButtonsRow: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  removeButtonsRow: css`
    && {
      border-radius: 7px;
    }
  `,
  removeButton: ({ theme }) => css`
    && {
      background-color: ${theme.colors.tertiary.red[60]};
      color: ${theme.colors.neutral.variant[0]};
      &:hover {
        background-color: ${theme.colors.tertiary.red[70]};
      }
    }
  `,
  titleRow: css`
    display: flex;
    align-items: center;
  `,
  footerActions: css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  `,
  titleRowReady: css`
    & [data-bulk-title-lead='mail'] {
      opacity: 1;
      transition: opacity 0.12s ease;
    }
    & [data-bulk-title-lead='delete'] {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.12s ease;
    }
    &:hover [data-bulk-title-lead='mail'] {
      opacity: 0;
    }
    &:hover [data-bulk-title-lead='delete'] {
      opacity: 1;
      pointer-events: auto;
    }
  `,
  titleLeadSlot: css`
    position: relative;
    flex-shrink: 0;
    width: 40px;
    height: 32px;
  `,
  titleLeadMail: css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  iconTitleRow: css`
    padding: 0px 10px 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  expandedContent: css`
    padding: 8px 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `,
  generatingContent: css`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 0;
  `,
  headerRow: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    height: 48px;
    width: 100%;
    justify-content: space-between;

    & > div:first-of-type {
      width: 100%;
    }

    & > div:nth-of-type(2) {
      gap: 20px;
      margin-left: 0;
    }

    &:hover {
      background-color: ${theme.colors.neutral.variant[5]};
    }
  `,
  endAdornmentGroup: css`
    display: flex;
    align-items: center;
    gap: 2px;
  `,
  endAdornment: ({ theme }) => css`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  rowSeparator: ({ theme }) => css`
    padding-bottom: 4px;
    border-bottom: 1px solid ${theme.colors.neutral.variant[10]};
  `,
  deleteButton: ({ theme }) => css`
    border-radius: 8px;
    &:hover {
      background-color: ${theme.colors.tertiary.red[20]};
    }
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
